// Test IDs for the public self-booking page (/reservas/:slug).

export const PUBLIC_BOOKING = {
  page: 'public-booking-page',
  loading: 'public-booking-loading',
  error: 'public-booking-error',
  langToggle: 'public-lang-toggle',
  langEs: 'public-lang-es',
  langEn: 'public-lang-en',
  stepper: 'public-booking-stepper',
  backButtonPrefix: 'public-booking-back-button-step-', // + stepNumber

  servicesList: 'public-services-list',
  servicesEmpty: 'public-services-empty',
  serviceCardPrefix: 'public-service-card-', // + serviceId
  servicePricePrefix: 'public-service-price-', // + serviceId (Fix AT, 2026-10-27)
  categoryTabPrefix: 'public-service-category-tab-', // + category (or "all")
  categoryHeadingPrefix: 'public-service-category-heading-', // + category
  readMoreButtonPrefix: 'public-service-read-more-', // + serviceId
  featuredServicesSection: 'public-featured-services-section',
  featuredServiceCardPrefix: 'public-featured-service-card-', // + serviceId

  professionalsList: 'public-professionals-list',
  anyProfessionalButton: 'public-any-professional-button',
  professionalCardPrefix: 'public-professional-card-', // + professionalId

  dateStrip: 'public-date-strip',
  dateOptionPrefix: 'public-date-option-', // + YYYY-MM-DD
  slotsGrid: 'public-slots-grid',
  slotsEmpty: 'public-slots-empty',
  slotOptionPrefix: 'public-slot-option-', // + HH:MM
  dateTimeContinueButton: 'public-datetime-continue-button',

  nameInput: 'public-patient-name-input',
  phoneInput: 'public-patient-phone-input',
  emailInput: 'public-patient-email-input',
  dobInput: 'public-patient-dob-input',
  emergencyNameInput: 'public-patient-emergency-name-input',
  emergencyPhoneInput: 'public-patient-emergency-phone-input',
  allergiesInput: 'public-patient-allergies-input',
  reasonInput: 'public-patient-reason-input',
  confirmButton: 'public-booking-confirm-button',
  bookingError: 'public-booking-error-message',

  confirmationScreen: 'public-booking-confirmation-screen',
  newBookingButton: 'public-booking-new-button',

  footer: 'public-booking-footer',
  instagramLink: 'public-footer-instagram-link',
  facebookLink: 'public-footer-facebook-link',
  acceptedPaymentMethods: 'public-accepted-payment-methods',

  promoLabelBadgePrefix: 'public-service-promo-badge-', // + serviceId
  kindBadgePrefix: 'public-service-kind-badge-', // + serviceId

  whatsappHelpButton: 'public-whatsapp-help-button',
  paymentLinkBanner: 'public-booking-payment-link-banner',
  payNowButton: 'public-booking-pay-now-button',
  financingBanner: 'public-booking-financing-banner',
  financingLink: 'public-booking-financing-link',
};
